// extracted by mini-css-extract-plugin
export default {"headerList":"styles_headerList__JSTuV","activeTab":"styles_activeTab__OVLr4"};